<template>
    <div>
        <div class="page">
            <div class="subpage">
                <div class="d-flex justify-space-between">
                    <h4 class="ml-2">{{ $dayjs(job.dateTargetCompletion ?? $dayjs()).format('ddd D MMM YYYY') }}</h4>
                    <div style="text-align:right; height:45px;">
                        <h4 class="font-italic mb-0">PRODUCTION SHEET</h4>
                        <small style="font-size:60%; position:relative; top:-5px;">[DOCTYPE: PRODSHEET]</small>
                    </div>                    
                </div>
                <div class="customer-box mt-0">
                    <v-row>
                        <v-col cols="8">
                            <h3>{{ job.contact.name }} <span v-if="isRework" class="rework-badge">REWORK</span></h3>
                            <h4>{{ job.customerNumber }}</h4>
                            <canvas v-if="showBarcode" id="barcode"></canvas>
                        </v-col>
                        <v-col cols="4" class="d-flex" style="flex-direction:row-reverse;">
                            <div class="mr-2 text-right">
                                <h1 style="font-size:26px;">{{ job.name }}</h1>
                            </div>
                            <job-qr-code :job-id="job.id"></job-qr-code>
                        </v-col>
                    </v-row>
                    
                </div>
                <div class="d-flex justify-space-between">
                    <div style="width:48%">
                        <v-sheet v-if="job.contact.jobCardMessage  && job.contact.jobCardMessage.length > 0" class="warranty-sheet" rounded color="orange-lighten-4">
                            <h4><v-icon icon="mdi-message-alert-outline"></v-icon> Critical Job Information</h4>
                            <p>{{ job.contact.jobCardMessage }}</p>
                        </v-sheet>
                        <v-sheet v-if="job.warrantyRequired" class="warranty-sheet" rounded color="orange-lighten-4">
                            <h4><v-icon icon="mdi-format-list-checks"></v-icon> Warranty Job</h4>
                            <div class="detail-table mt-0">
                                <div>Powder coat 4 samples</div>
                            </div>
                        </v-sheet>
                        <v-sheet v-if="job.packaging" class="warranty-sheet" rounded color="orange-lighten-4">
                            <h4><v-icon icon="mdi-archive-star-outline"></v-icon> Packaging Requirements</h4>
                            <div class="detail-table mt-0">
                                <div>Use packaging type: <h4 class="d-inline">{{ packagingName  }}</h4></div>
                            </div>
                        </v-sheet>
                        <v-sheet v-if="job.comment" class="warranty-sheet" rounded color="orange-lighten-4">
                            <h4><v-icon icon="mdi-archive-star-outline"></v-icon> Comment</h4>
                            <div class="detail-table mt-0">
                                <h4 class="d-inline">{{ job.comment }}</h4>
                            </div>
                        </v-sheet>
                        <table class="detail-table">
                            <tbody>
                                <tr>
                                    <th class="text-left">Description</th>
                                    <th class="text-right">Quantity</th>
                                </tr>
                                <tr v-for="item in dataItems" :key="item.description">
                                    <td>
                                        <span v-html="item.description.replaceAll('@', '<br />@')"></span>
                                    </td>
                                    <td class="text-right">
                                        {{ item.quantity }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div v-if="job.jobDiagrams">
                            <img v-for="file in job.jobDiagrams" :key="file.id" :src="file.fileLink" alt="img" class="job-diagram" />
                        </div>
                    </div>
                    <div class="pl-4" style="width:52%">
                        <qa-checklist :job="job"></qa-checklist>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="job.contact.nuwall" class="page">
            <div class="subpage">
                <div class="w-100 d-flex justify-space-between mb-3">
                    <h1>{{ job.name }}</h1>
                    <div>
                        <v-img height="50"
                               width="50"
                               style="background:black;"
                               src="/assets/logo.png"></v-img>
                    </div>
                </div>
                <div class="w-100 d-flex justify-space-between">
                    <h3>{{ $dayjs(job.created).format('ddd D MMM YYYY') }}</h3>
                    <div style="text-align:right; height:45px;">
                        <h3 class="font-italic mb-0">STOCK SHEET</h3>
                        <small style="font-size:60%; position:relative; top:-5px;">[DOCTYPE: STOCKSHEET]</small>
                    </div>
                </div>
                <div class="customer-box">
                    <h2>{{ job.contact.name }}</h2>
                    <h3>{{ job.customerNumber }}</h3>
                </div>
                <i style="font-size:85%; font-weight:500;">Damage Source is who caused the damage - Nuwall, MCK or P88.</i>
                <table class="detail-table">
                    <tbody>
                        <tr>
                            <th class="text-left border-e-sm" style="width:29%">Description</th>
                            <th class="text-left border-e-sm" style="width:10%">Length</th>
                            <th class="text-right border-e-sm" style="width:10%">Picked Stock Qty</th>
                            <th class="border-e-sm" style="width:29%">Picked Reason</th>
                            <th class="border-e-sm" style="width:12%">Damage Source</th>
                            <th class="text-right border-e-sm" style="width:10%">Stock → Strip Qty</th>
                        </tr>
                        <tr v-for="(item, index) in quantityDataItems" :key="index">
                            <td class="border-e-sm">
                                {{item.description}}
                            </td>
                            <td class="text-right border-e-sm">
                                {{ item.length }} <span class="text-muted">M</span>
                            </td>
                            <td class="text-right border-e-sm">
                            </td>
                            <td class="text-right border-e-sm">
                            </td>
                            <td class="text-right border-e-sm">
                            </td>
                            <td class="text-right border-e-sm">
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="page">
            <div class="subpage">
                <div class="w-100 d-flex justify-space-between mb-3">
                    <h1>{{ job.name }}</h1>
                    <div>
                        <v-img height="50"
                               width="50"
                               style="background:black;"
                               src="/assets/logo.png"></v-img>
                    </div>
                </div>
                <div class="w-100 d-flex justify-space-between">
                    <h3>{{ $dayjs(job.created).format('ddd D MMM YYYY') }}</h3>
                    <div style="text-align:right; height:45px;">
                        <h3 class="font-italic mb-0">PACKING SHEET</h3>
                        <small style="font-size:60%; position:relative; top:-5px;">[DOCTYPE: PACKSHEET]</small>
                    </div>
                </div>
                <div class="customer-box">
                    <h2>{{ job.contact.name }}</h2>
                    <h3>{{ job.customerNumber }}</h3>
                </div>
                <table class="detail-table">
                    <tr>
                        <th class="text-left">Description</th>
                        <th class="text-right">Quantity</th>
                    </tr>
                    <tr v-for="item in dataItems" :key="item.description">
                        <td>
                            {{ item.description }}
                        </td>
                        <td class="text-right">
                            {{ item.quantity }}
                        </td>
                    </tr>
                </table>
                <div class="d-flex justify-space-between collection-details">
                    <div>
                        Packed By
                    </div>
                    <div>
                        Name:<span class="line"></span>
                    </div>
                    <div>
                        Signature:<span class="line"></span>
                    </div>
                    <div>
                        Date:<span class="line" style="width:80px"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped lang="scss">
    @import '../../styles/portraitprint.scss';
    .job-diagram {
        width: 100%;
        height: auto;
        max-height: 150px;
        object-fit: contain;
        display: block;
        margin-bottom:4px;
    }
    .rework-badge {
        background-color: #E53935;
        color: white;
        display: inline-block;
        padding-top: 4px;
        padding-bottom: 4px;
        padding-left: 10px;
        padding-right: 10px;
        border-radius: 10px;
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
    }
    .warranty-sheet {
        padding: 5px;
        font-size: 12px;
        border: 1px solid black;
        margin-top: 5px;
    }
    .customer-box {
        width: 100%;
        border: 1px solid black;
        margin-top: 5px;
        margin-bottom: 5px;
        padding: 5px;
    }
    .box-header {
        width: 100%;
        padding: 2px;
        border-left: 1px solid black;
        border-right: 1px solid black;
        border-top:1px solid black;
        font-family:monospace;
    }
    .qa-box {
        font-size:11px;
    }

    .customer-box .header {
        font-size: 12px;
        display: inline-block;
        width: 100%;
        text-decoration: underline;
    }

    .collection-details {
        margin-top: 15px;
        font-size: 12px;
    }

    .line {
        display: inline-block;
        width: 150px;
        border-bottom: 1px solid black;
        margin-left: 3px;
    }
</style>
<script>
    var JsBarcode = require('jsbarcode');
    var { createCanvas } = require("canvas");
    import { getNuwallLength, removeNuwallLength } from "../../mixins/jobMixins";
    function initialState() {
        return {
            loading: false,
            hideBarcode: true
        };
    }
    export default {
        name: "JobCard",
        data: function () {
            return initialState();
        },
        mounted: function () { 
            if (this.showBarcode){
                // Generate barcode
                JsBarcode("#barcode", this.job.customerNumberClean, {
                  format: "CODE39",
                  height: 20,
                  width: 1,
                  displayValue: false
                });
            }
        },
        props: {
            job: Object
        },
        methods: {
        },
        computed: {
            dataItems() {
                if (this.job){
                    if (this.job.jobItemTasks && this.job.jobItemTasks.length > 0){
                        return this.job.jobItemTasks.map(item => {
                            return { description: item.itemDescription, quantity: item.quantity };
                        });
                    } else {
                        return this.job.jobItems;
                    }
                }
                return [];
            },
            quantityDataItems() {
                let items = [];

                if (this.dataItems.length > 0) {
                    items = this.dataItems.filter(item => {
                        return item.quantity > 0 && !item.description.startsWith("Colour");
                    }).map(item => {
                        return {
                            description: removeNuwallLength(item.description),
                            quantity: item.quantity,
                            length: getNuwallLength(item.description)
                        };
                    });
                }

                // Add 10 blank items
                for (let i = 0; i < 10; i++) {
                    items.push({ description: '\u00A0', quantity: '', length: '' });
                }

                return items;
            },
            packagingName() {
                if (this.job && this.job.packaging){
                    return this.$constants.jobs.packaging.find(item => item.value == this.job.packaging).title;
                }
                return null;
            },
            showBarcode() {
                return this.job && this.job.customerNumberClean && this.job.contact.id == 522;
            },
            isRework() {
                return this.job && this.job.taskJobTag == 'Rework';
            }
        }
    };
</script>